export const TABLE = 'TABLE' as const;
export const TREE_TABLE = 'TREE_TABLE' as const;

export type TableFacade = typeof TABLE | typeof TREE_TABLE;
